import { ThemeOptions } from '@mui/material';

/**
 * Theme typography options that are the same across both the dark and light themes.
 */
export function getTypography(): ThemeOptions['typography'] {
  // Font weights should correspond with the expected CSS imports in the README.md
  const fontWeightLight = 300;
  const fontWeightRegular = 400;
  const fontWeightMedium = 500;
  const fontWeightBold = 600;

  return {
    fontFamily: '"Inter", sans-serif',

    fontWeightLight,
    fontWeightRegular,
    fontWeightMedium,
    fontWeightBold,

    allVariants: {
      fontVariantLigatures: 'none',
    },
    h1: {
      fontSize: '1.5rem', // 24px
      fontWeight: fontWeightBold,
      lineHeight: '32px',
    },
    h2: {
      fontSize: '1.25rem', // 20px
      fontWeight: fontWeightBold,
      lineHeight: '28px',
    },
    h3: {
      fontSize: '1rem', // 16px
      fontWeight: fontWeightBold,
      lineHeight: '24px',
    },
    h4: {
      fontSize: '0.875rem', // 14px
      fontWeight: fontWeightBold,
      lineHeight: '22px',
    },
    h5: undefined,
    h6: undefined,

    body1: {
      fontSize: '0.875rem', // 14px
      fontWeight: fontWeightRegular,
      lineHeight: '20px',
    },
    body2: {
      fontSize: '0.75rem', // 12px
      fontWeight: fontWeightRegular,
      lineHeight: '18px',
    },
    subtitle1: {
      fontSize: '1rem', // 16px
      fontWeight: fontWeightRegular,
      lineHeight: '24px',
      letterSpacing: 'normal',
    },
    subtitle2: {
      fontSize: '0.875rem', // 14px
      fontWeight: fontWeightMedium,
      lineHeight: '22px',
      letterSpacing: 'normal',
      textTransform: 'uppercase',
    },

    button: {
      // 14px
      fontSize: '0.875rem',
      fontWeight: fontWeightMedium,
      // 20 px
      lineHeight: '1.25rem',
      textTransform: 'none',
      letterSpacing: 'normal',
    },
    caption: {
      fontSize: '0.6875rem', // 11px
      fontWeight: fontWeightRegular,
      lineHeight: '16px',
    },
    overline: undefined,
    overline1: {
      fontSize: '0.875rem', // 14px
      fontWeight: fontWeightRegular,
      lineHeight: '20px',
      letterSpacing: 'normal',
      textTransform: 'uppercase',
    },
    overline2: {
      fontSize: '0.75rem', // 12px
      fontWeight: fontWeightRegular,
      lineHeight: '18px',
      letterSpacing: 'normal',
      textTransform: 'uppercase',
    },
    code: {
      // Use system default monospace font
      fontFamily: 'monospace',
      fontSize: '0.75rem', // 12px
      fontWeight: fontWeightRegular,
      lineHeight: '20px',
    },
  };
}
